<template lang="pug">
#diagnostico-socioambiental-view
    .card-socioambiental
        header
            h1
                .el-icon-arrow-left.voltar(@click='clear')
                | Diagnóstico Socioambiental

        .d-flex.flex-column.mb-3(v-if='!dadosConsulta')
            p Utilize um dos campos abaixo para realizar o diagnóstico
            .pesquisa
                label(for='barra-pesquisa') Pesquisar por um CPF/CNPJ, código CAR, código da parcela ou número do INCRA
                el-input#barra-pesquisa(
                    type='text',
                    placeholder='Digite o CPF/CNPJ, CAR, Parcela ou INCRA',
                    style='width: 100%',
                    v-model='pesquisa',
                    @change='pesquisar'
                )
                    i.el-input__icon.el-icon-info(
                        slot='suffix',
                        :title='$t("mensagens.blocoFiltros.infos.pesquisarCarDocumento")'
                    )

            .upload
                label Pesquisar por arquivo KML, KMZ, WKT ou Shapefile
                el-upload.upload-demo(
                    drag,
                    :file-list='fileList',
                    action='alert',
                    :auto-upload='false',
                    :on-change='onLoadFile',
                    :on-remove='onRemoveFile',
                    :on-exceed='onLimitExceed',
                    :limit='1',
                    ref='upload'
                )
                    i.el-icon-upload(style='margin-top: 40px')
                    .el-upload__text Arraste os arquivos aqui ou <em>clique para subir</em>

            .flexLine
                .mt-1(:class='[pesquisaValida ? pesquisaValidaClass : error]') Pesquisa inválida
                .row.my-2.mr-0.d-flex.flex-row-reverse
                    el-button(
                        type='primary',
                        icon='el-icon-search',
                        @click='pesquisar'
                    )
                        | Pesquisar

        .dados(v-if='dadosConsulta')
            header.mb-3
                p Resultados do Diagnóstico Socioambiental
                p.valor-pesquisado {{ pesquisado }}

            section.mb-3(v-if='informacoes_gerais !== null')
                p.mt-2.mb-3 {{ $t('mensagens.diagnosticoSocioambiental.informacoesGerais') }}:
                h4.pl-3.informacoes-gerais(v-if='informacoes_gerais.area_ha') Município - Estado: {{ informacoes_gerais.area_ha }}
                h4.pl-3.informacoes-gerais(v-if='informacoes_gerais.area_ha') Área (ha): {{ informacoes_gerais.area_ha }}
                h4.pl-3.informacoes-gerais Bioma: {{ informacoes_gerais.bioma ? informacoes_gerais.bioma : '--' }}
                h4.pl-3.informacoes-gerais Faixa de fronteira: {{ informacoes_gerais.faixa_fronteira !== null ? (informacoes_gerais.faixa_fronteira ? 'Sim' : 'Não') : '--' }}
                h4.pl-3.informacoes-gerais(
                    v-if='informacoes_gerais.moduloFiscal'
                ) Modulo Fiscal: {{ informacoes_gerais.moduloFiscal }}
                h4.pl-3.informacoes-gerais(v-if='informacoes_gerais.situacao') Situação: {{ informacoes_gerais.situacao }}
                h4.pl-3.informacoes-gerais(v-if='informacoes_gerais.condicao') Condição: {{ informacoes_gerais.condicao }}

            h3.mb-3
                i.el-icon-finished
                b.resultado-analise-titulo Resultado da Análise
            DiagnosticoSocioambiental(
                ref='refDiagnosticoSocioambiental',
                v-if='refMapa',
                :dadosConsulta='dadosConsulta',
                :habilitar-opacidade='true',
                :indexCollapse=0,
                v-bind:cpfCnpj='getCpfCnpj()',
                v-bind:car='getCar()',
                @index-aberto='mostrarAreasDiagnosticoNoMapa',
                :mapaLeaflet='refMapa',
                :habilitar-zoom-restricao='true'
            )

        .dados.mt-3(v-if='dadosConsultaBuffer')
            h3.mb-3
                i.el-icon-connection
                b {{ tituloProximidade }}
            DiagnosticoSocioambiental(
                v-if='refMapa',
                :dadosConsulta='dadosConsultaBuffer',
                :habilitar-opacidade='true',
                :habilitar-sinal-aviso='dadosConsultaBuffer.habilitarAlertaProximidade',
                :indexCollapse=1,
                v-bind:cpfCnpj='getCpfCnpj()',
                v-bind:car='getCar()',
                @index-aberto='mostrarAreasDiagnosticoNoMapa',
                :mapaLeaflet='refMapa',
                :habilitar-zoom-restricao='true'
            )

        .exportar-btn
            el-dropdown.float-right.my-3(
                v-if='pesquisaValida && pesquisa !== null && dadosConsulta !== null'
            )
                el-button(
                    type='primary',
                    @click='marcarExportacaoDiagnosticPdf'
                ) Marcar para exportação

            el-dropdown.float-right.my-3(
                v-if='pesquisaValida && pesquisa !== null && dadosConsulta !== null',
                v-bind:disabled='loadingPDF'
            )
                el-button(
                    type='primary',
                    @click='!hasDadosConsultaBuffer ? exportarPdfDiagnosticoSocio(false) : undefined'
                )
                    i.el-icon-loading(v-if='loadingPDF')
                    span Exportar Diagnóstico

                el-dropdown-menu.downloadMenu(
                    v-if='hasDadosConsultaBuffer',
                    slot='dropdown'
                )
                    el-dropdown-item
                        el-button(
                            type='primary',
                            @click='exportarPdfDiagnosticoSocio(false)',
                            icon='el-icon-download'
                        ) Território
                    br
                    el-dropdown-item.spaceProximidades
                        el-button(
                            type='primary',
                            @click='exportarPdfDiagnosticoSocio(true)',
                            icon='el-icon-download'
                        ) Território + proximidades

    .mapa.w-100.h-100
        mapa(
            ref='mapa',
            :showStatesLayers='true',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :height='"100%"',
            :idMapa='"mapaDiagnosticoSocioambiental"',
            @diagnostico='realizarDiagnosticoPeloMapa',
            :atualizarMapa='true',
            :cluster='false',
            :menuMaior='true'
        )
    div(v-if='mostrarModalDadosCpfCnpj')
        ModalSelecionarDadosCpfCnpj(
            :show='mostrarModalDadosCpfCnpj',
            :cpfCnpj='pesquisa',
            :dados='dados',
            tipo='DIAGNOSTICO',
            @voltar='mostrarModalDadosCpfCnpj = false',
            @retornarDadosSelecionados='realizarDiagnosticoDadoCpfCnpj'
        )
</template>

<script>
import L from 'leaflet';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import validators from '@/utils/validators';
import formatters from '@/utils/formatters';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { retryOperation } from '@/utils/retry-operation';

import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';

import { sortBy } from 'lodash';

import geoJsonConverter from '@/utils/conversorGeojson';

import { mapGetters, mapActions } from 'vuex';
import { TipoAcaoGeometriaDesenhada } from '@/constants/TipoAcaoGeometriaDesenhada';

import CarService from '@/services/car/CarService';
import MunicipioService from '@/services/MunicipioService';
import ModalSelecionarDadosCpfCnpj from '@/components/ModalSelecionarDadosCpfCnpj';
import EventBus from '@/utils/eventBus';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import SigefService from '@/services/SigefService';
import CarUtils from '@/utils/CarUtils';

export default {
    name: 'index',

    components: {
        Mapa,
        DiagnosticoSocioambiental,
        ModalSelecionarDadosCpfCnpj
    },

    data() {
        return {
            dadosConsulta: null,
            dadosConsultaBuffer: null,
            pesquisa: '',
            pesquisado: '',
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: true,
                diagnostico: true
            },
            pesquisaValida: true,
            tipoPesquisa: null,
            loadingPDF: false,
            error: 'error',
            pesquisaValidaClass: 'pesquisa-valida',
            fileList: [],
            uploadFile: null,
            camadasAtivas: [],
            mostrarModalDadosCpfCnpj: false,
            informacoes_gerais: null,
            carsCpfCnpj: [],
            carVinculadoCpfCnpj: null,
            markers: null,
            territorioId: null,
            municipioBuffer: {},
            dados: {
                carEstadoPaginado: [],
                existemDados: false,
                sigef: []
            },
            tituloProximidade: '',
            idDiagnosticoSocioambiental: null,
            geometriaSigef: null,
            refMapa: null
        };
    },

    computed: {
        ...mapGetters([
            'geometriaDesenhadaAcao',
            'acaoEscolhida',
            'usuarioLogado'
        ]),
        hasDadosConsultaBuffer() {
            return this.dadosConsultaBuffer !== null;
        }
    },

    mounted() {
        this.refMapa = this.$refs.mapa;
    },

    async created() {
        EventBus.$off('mapa:buffer-click');
        this.$nextTick(function () {
            EventBus.$on('mapa:buffer-click', this.bufferCLick);
        });

        if (
            this.acaoEscolhida &&
            this.acaoEscolhida.acao ===
                TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
        ) {
            this.tipoPesquisa = 'GEOMETRIA';
            await this.buscarDadosConsulta();
            await this.mostrarTerritorioNoMapa(this.geometriaDesenhadaAcao);
        }

        if (this.$route.params.pesquisa) {
            this.tipoPesquisa = 'CODIGOCAR';
            this.pesquisa = this.$route.params.pesquisa;
            this.pesquisar();
        }

        this.$bus.$on('mapa:camadas-ativas-diagnostico', data => {
            this.camadasAtivas = [];
            data.map(layer => {
                this.camadasAtivas.push(layer.layerName);
            });
        });
    },

    beforeDestroy() {
        this.removerAcaoEscolhida();
        this.removerGeometriaDesenhadaAcao();
    },

    watch: {
        pesquisa: function (value) {
            if (!value) return;

            const tipoPesquisa = {
                0: this.uploadFile ? 'ARQUIVO' : null,
                13: 'INCRA',
                14: validators.validarCpfCnpj(value) ? 'CPF_CNPJ' : null,
                18: validators.validarCpfCnpj(value) ? 'CPF_CNPJ' : null,
                36: 'SIGEF',
                43: 'CODIGOCAR'
            };

            this.tipoPesquisa = tipoPesquisa[value.length];
            this.pesquisaValida = this.tipoPesquisa != null;

            this.pesquisa = this.mascaraPesquisa(value);
        },
        uploadFile: function () {
            this.pesquisaValida = true;
            this.tipoPesquisa = this.uploadFile ? 'ARQUIVO' : 'null';
        }
    },

    methods: {
        ...mapActions([
            'removerGeometriaDesenhadaAcao',
            'removerAcaoEscolhida',
            'setGeometriaDesenhadaAcao',
            'setAcaoEscolhida',
            'setMarcarExportar_PDF'
        ]),

        getCpfCnpj() {
            if (
                this.tipoPesquisa === 'CPF_CNPJ' ||
                this.tipoPesquisa === 'CPF_CNPJ_NEW'
            ) {
                return this.pesquisa;
            }
            return null;
        },

        getCar() {
            if (this.tipoPesquisa === 'CODIGOCAR') {
                const car = this.pesquisa.toUpperCase();
                if (car.startsWith('PA')) {
                    return this.pesquisa;
                }
            }
            return null;
        },

        async clear() {
            this.pesquisa = '';
            this.pesquisado = '';
            this.onRemoveFile();
            this.$bus.$emit('mapa:show-buffer', false);
            this.clearMarkes();
            this.dadosConsulta = null;
            this.dadosConsultaBuffer = null;
            this.removerAcaoEscolhida();
            this.$router.go(-1);
        },

        realizarDiagnosticoPeloMapa() {
            this.setGeometriaDesenhadaAcao(this.geometriaDesenhadaAcao);
            this.setAcaoEscolhida({
                acao: TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            });

            this.mostrarTerritorioNoMapa(this.geometriaDesenhadaAcao);
            this.tipoPesquisa = 'GEOMETRIA';
            this.buscarDadosConsulta();
        },

        async pesquisar() {
            if (!this.pesquisaValida) {
                this.$notify.warning(
                    'Informação inválida. Confira o campo e tente novamente'
                );
                return;
            }

            if (
                this.acaoEscolhida &&
                this.acaoEscolhida.acao ===
                    TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            ) {
                this.removerAcaoEscolhida();
                this.removerGeometriaDesenhadaAcao();
            }

            await this.buscarDadosConsulta();

            if (this.tipoPesquisa === 'ARQUIVO') {
                this.pesquisa = '';
            } else {
                this.fileList = [];
                this.uploadFile = null;
            }
            this.dadosConsultaBuffer = null;
            this.mostrarTerritorioNoMapa();
        },

        async bufferCLick() {
            // Fecha o collapse aberto
            if (this.$refs['refDiagnosticoSocioambiental']) {
                this.$refs['refDiagnosticoSocioambiental'].indexCollapseRow =
                    '';
            }
            let response = null;
            try {
                const geometria = Array.isArray(
                    this.dadosConsulta.imovel.geometria
                )
                    ? this.dadosConsulta.imovel.geometria.map(g =>
                          JSON.stringify(g)
                      )
                    : [JSON.stringify(this.dadosConsulta.imovel.geometria)];

                response =
                    await DiagnosticoSocioambientalService.analisarBuffer(
                        geometria,
                        this.idDiagnosticoSocioambiental
                    );

                const diagnosticos = [];
                response.data.dados.forEach(d =>
                    d.forEach(t => {
                        diagnosticos.push(t);
                    })
                );

                const geometrias = [];
                response.data.geometrias.forEach(g => {
                    geometrias.push(JSON.parse(g));
                });

                this.dadosConsultaBuffer = {
                    diagnosticos:
                        this.ordenarDiagnosticoPorCamada(diagnosticos),
                    geometria: geometrias,
                    habilitarAlertaProximidade:
                        response.data.habilitarAlertaProximidade
                };

                this.tituloProximidade = response.data.tituloProximidade;

                this.mostrarTerritorioNoMapa();
            } catch (e) {
                this.$notify.error({
                    message: 'Erro ao buscar dados do buffer'
                });
            }
        },

        ordenarDiagnosticoPorCamada(diagnosticos) {
            diagnosticos = diagnosticos.map(d => ({
                ...d,
                camada: { ...d.camada, opacidade: 100 },
                nivelAlerta: d.nivelAlerta
            }));

            diagnosticos.forEach(diagnostico => {
                if (diagnostico.camada.nome === 'Áreas embargadas') {
                    diagnostico.camada.nome = 'Áreas embargadas (IBAMA)';
                }
            });

            return sortBy(diagnosticos, [
                diagnostico => diagnostico.camada.codigo
            ]);
        },

        async getDadosMunicipio(item) {
            const idMunicipio = item.properties.id_municipio;

            if (this.municipioBuffer[idMunicipio]) {
                return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
            } else {
                try {
                    const { data } = await MunicipioService.getMunicipioById(
                        idMunicipio
                    );
                    this.municipioBuffer[idMunicipio] = data;
                    return `${this.municipioBuffer[idMunicipio].nome} - ${this.municipioBuffer[idMunicipio].estado.sigla}`;
                } catch (e) {
                    this.$notify.error({
                        message: 'Ocorreu um erro ao buscar dados do município'
                    });
                    return '-';
                }
            }
        },

        async buscarDadosConsulta() {
            this.territorioId = null;
            let tipoConsulta = null;
            this.geometriaSigef = null;

            if (this.tipoPesquisa === 'SIGEF') {
                const { data } = await SigefService.buscarGeometriaParcela(
                    this.pesquisa
                );

                if (data !== '') {
                    this.geometriaSigef = JSON.parse(data);
                    this.pesquisaValida = true;
                } else {
                    this.$notify.warning(
                        'A parcela inserida não foi encontrada. Favor verificar se o número está correto e tentar novamente. Se esta situação persistir, favor entrar em contato com os administradores da plataforma Lyra.'
                    );
                    return;
                }
            }

            try {
                let consultaResponse = null;
                switch (this.tipoPesquisa) {
                    case 'CODIGOCAR':
                        tipoConsulta = 'CAR';
                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'CODIGOCAR',
                                this.pesquisa.toUpperCase()
                            );
                        break;
                    case 'ARQUIVO':
                        tipoConsulta = 'Arquivo';
                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'GEOMETRIA',
                                'geometria',
                                true,
                                JSON.stringify(this.uploadFile.file)
                            );
                        break;
                    case 'CPF_CNPJ':
                        tipoConsulta = 'CPF/CNPJ';
                        const cpfCnpj = this.pesquisa.replace(/\D/g, '');
                        const cars = await this.buscarCarPorCpfCnpjVinculado(
                            cpfCnpj
                        );
                        const listaSigef = await this.buscarDadosSigefCpfCnpj(
                            cpfCnpj
                        );

                        this.dados = {
                            listaSigef,
                            ...cars
                        };

                        if (this.dados.existemDados || listaSigef.length) {
                            this.mostrarModalDadosCpfCnpj = true;
                            return;
                        } else {
                            consultaResponse =
                                await DiagnosticoSocioambientalService.consultar(
                                    'CPF_CNPJ',
                                    formatters.cpfCnpjFormatToNumeral(cpfCnpj)
                                );
                        }
                        break;
                    case 'CPF_CNPJ_NEW':
                        tipoConsulta = 'CPF/CNPJ';
                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'CPF_CNPJ',
                                formatters.cpfCnpjFormatToNumeral(
                                    this.pesquisa.replace(/\D/g, '')
                                )
                            );
                        break;
                    case 'GEOMETRIA':
                    case 'SIGEF':
                        this.tipoConsulta = 'GEOMETRIA';
                        let geometriaConsulta = [this.geometriaDesenhadaAcao];

                        if (this.geometriaSigef) {
                            geometriaConsulta = [this.geometriaSigef];
                        }

                        consultaResponse =
                            await DiagnosticoSocioambientalService.consultar(
                                'GEOMETRIA',
                                'geometria',
                                true,
                                JSON.stringify(geometriaConsulta)
                            );
                        this.mostrarTerritorioNoMapa(geometriaConsulta);
                        this.tipoPesquisa = 'GEOMETRIA';
                        break;
                    case 'INCRA':
                        tipoConsulta = 'INCRA';
                        const listaSigefINCRA =
                            await this.buscarDadosSigefINCRA(this.pesquisa);

                        this.dados = {
                            listaSigef: listaSigefINCRA
                        };

                        if (listaSigefINCRA.length) {
                            this.pesquisa = 'INCRA';
                            this.mostrarModalDadosCpfCnpj = true;
                            return;
                        } else {
                            this.$notify.warning(
                                'Não foi encontrada nenhum parcela relacionada ao número do INCRA inserido'
                            );
                        }
                        break;
                }

                if (consultaResponse) {
                    this.informacoes_gerais =
                        consultaResponse.data.informacoes_gerais;
                }

                this.idDiagnosticoSocioambiental =
                    consultaResponse.data.idDiagnosticoSocioambiental;

                let dados = consultaResponse.data.dataCAR;
                if (dados.length === 0) {
                    this.$notify.warning({
                        message: 'O CAR informado não foi encontrado'
                    });
                } else {
                    this.territorioId = consultaResponse.data.territorioId;

                    this.dadosConsulta = dados[0].diagnosticos
                        ? {
                              ...dados[0],
                              diagnosticos: this.ordenarDiagnosticoPorCamada(
                                  dados[0].diagnosticos
                              )
                          }
                        : {
                              diagnosticos:
                                  this.ordenarDiagnosticoPorCamada(dados)
                          };

                    if (this.tipoPesquisa === 'ARQUIVO') {
                        this.dadosConsulta.imovel = {
                            geometria: this.uploadFile.file
                        };
                    }

                    if (this.tipoPesquisa === 'GEOMETRIA') {
                        this.dadosConsulta.imovel = {
                            geometria: this.geometriaSigef
                                ? this.geometriaSigef
                                : this.geometriaDesenhadaAcao
                        };
                    }

                    this.pesquisado =
                        this.tipoPesquisa === 'ARQUIVO'
                            ? 'Pesquisa por arquivo KML, KMZ, WKT ou Shapefile'
                            : this.pesquisa;
                }
            } catch (error) {
                if (tipoConsulta === 'CAR') {
                    this.$notify.error({
                        message:
                            'O CAR inserido não foi encontrado. Favor verificar se o número de recibo inserido está correto e tentar novamente. Se esta situação persistir, favor entrar em contato com os administradores da plataforma Lyra.'
                    });
                    return;
                }

                this.$notify.error({
                    message:
                        'Não foi possível consultar o(a) ' +
                        tipoConsulta +
                        ' inserido(a).'
                });
            }
        },

        realizarDiagnosticoDadoCpfCnpj(dado) {
            this.mostrarModalDadosCpfCnpj = false;
            if (dado.codigo) {
                this.pesquisa = dado.codigo;
                this.tipoPesquisa = 'CODIGOCAR';
            } else if (dado.codigoParcela) {
                this.pesquisa = dado.codigoParcela;
                this.tipoPesquisa = 'SIGEF';
            } else {
                this.pesquisa = dado;
                this.tipoPesquisa = 'CPF_CNPJ_NEW';
                this.buscarDadosConsulta();
            }
        },
        addMarker(geometria) {
            this.clearMarkes();

            let pinIcon = L.icon({
                iconUrl:
                    'https://lyra-v1.s3.amazonaws.com/Map-Marker-PNG-File.png',
                iconSize: [36, 36]
            });

            let marker = L.marker(
                [geometria.coordinates[1], geometria.coordinates[0]],
                {
                    icon: pinIcon,
                    draggable: true
                }
            );

            marker.addTo(this.markers);
            this.markers.addTo(this.$refs.mapa.mapa);
        },

        clearMarkes() {
            if (this.markers) {
                this.$refs.mapa.mapa.removeLayer(this.markers);
            }
            this.markers = L.markerClusterGroup();
        },

        mostrarTerritorioNoMapa(geometria, clearLayers) {
            if (clearLayers == null || clearLayers) {
                this.layersMaps = [];
            }

            const layersToAdd = [];

            if (
                this.acaoEscolhida &&
                this.acaoEscolhida.acao ===
                    TipoAcaoGeometriaDesenhada.DIAGNOSTICO_SOCIOAMBIENTAL
            ) {
                geometria = this.geometriaDesenhadaAcao;
                this.dadosConsulta = {
                    imovel: { geometria: this.geometriaDesenhadaAcao },
                    ...this.dadosConsulta
                };
            }

            if (geometria) {
                if (geometria.type === 'Point') {
                    this.addMarker(geometria);
                } else {
                    layersToAdd.push({
                        style: getEstiloGeometria('area'),
                        name: 'Território',
                        geoJson: geometria
                    });
                }
            }
            if (this.dadosConsulta && this.dadosConsulta.imovel) {
                layersToAdd.push({
                    style: getEstiloGeometria('car'),
                    name: 'Car',
                    geoJson: this.dadosConsulta.imovel.geometria
                });
                this.$bus.$emit('mapa:show-buffer', true);
            }
            if (
                this.dadosConsultaBuffer &&
                this.dadosConsultaBuffer.geometria
            ) {
                layersToAdd.push({
                    style: getEstiloGeometria('area'),
                    name: 'Território',
                    geoJson: this.dadosConsultaBuffer.geometria
                });

                this.$bus.$emit('mapa:show-buffer', false);
            }
            if (this.geometriaSigef) {
                layersToAdd.push({
                    style: getEstiloGeometria('area'),
                    name: 'Território_Sigef',
                    geoJson: this.geometriaSigef
                });
            }

            layersToAdd.forEach(l => {
                this.layersMaps.push(l);
            });
        },

        mostrarAreasDiagnosticoNoMapa(
            restricao,
            indexCollapse,
            indexRestricao
        ) {
            this.mostrarTerritorioNoMapa();
            if (indexRestricao === '') return;

            const diagnostico =
                indexCollapse === 0
                    ? this.dadosConsulta.diagnosticos[indexRestricao]
                    : this.dadosConsultaBuffer.diagnosticos[indexRestricao];

            const opacidade =
                diagnostico.camada.opacidade >= 0.0
                    ? diagnostico.camada.opacidade / 200
                    : 0.5;

            const areas = diagnostico.resultados.filter(
                resultado => resultado.geometria || resultado.geometry
            );

            areas.forEach((area, index) => {
                const geometria = area.geometria || area.geometry;

                if (geometria) {
                    this.layersMaps.push({
                        name: `AreaDiagnostico_red_${indexCollapse}_${indexRestricao}_${index}`,
                        group: `grupo-restricoes-${indexCollapse}-${indexRestricao}`,
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            opacity: opacidade,
                            fillOpacity: opacidade
                        },
                        geoJson: geometria
                    });

                    const pin = L.icon({
                        iconUrl:
                            'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                        iconSize: [18, 18]
                    });

                    this.layersMaps.push({
                        name: `CentroidDiagnostico_${index}_${indexCollapse}`,
                        icon: pin,
                        geoJson: centroidFromGeoJSON.get(geometria)
                    });
                }
            });
        },

        async exportarPdfDiagnosticoSocio(buffer) {
            if (!this.usuarioLogado) {
                this.$notify.error({
                    message: 'Usuário deslogado!'
                });
                return;
            }

            try {
                await connect();
            } catch {
                this.$notify.error({
                    message:
                        'Não foi possível se conectar na api para realizar o download do pdf!'
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                    response => {
                        if (response) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = 'diagnosticos-socioambientais.pdf';

                            const currentDate = new Date();
                            const formattedDate = `${currentDate.getFullYear()}${String(
                                currentDate.getMonth() + 1
                            ).padStart(2, '0')}${String(
                                currentDate.getDate()
                            ).padStart(2, '0')}`;
                            const formattedTime = `${String(
                                currentDate.getHours()
                            ).padStart(2, '0')}${String(
                                currentDate.getMinutes()
                            ).padStart(2, '0')}${String(
                                currentDate.getSeconds()
                            ).padStart(2, '0')}`;

                            const newFileName = fileName.replace(
                                '.pdf',
                                `-${formattedDate}-${formattedTime}.pdf`
                            );

                            link.href = linkSource;
                            link.download = newFileName;
                            link.click();
                            link.remove();
                        } else {
                            this.$notify.error({
                                message: 'Não foi possível exportar o pdf!'
                            });
                        }
                        this.loadingPDF = false;
                        disconnect();
                    }
                );

                this.loadingPDF = true;
                let documento = {};

                if (this.tipoPesquisa === 'CODIGOCAR') {
                    documento.value = this.pesquisa.toUpperCase();
                } else if (this.tipoPesquisa === 'ARQUIVO') {
                    documento.value = JSON.stringify(this.uploadFile.file);
                    documento.nomeArquivo = this.uploadFile.name;
                } else if (this.tipoPesquisa === 'GEOMETRIA') {
                    documento.value = JSON.stringify([
                        this.geometriaSigef
                            ? this.geometriaSigef
                            : this.geometriaDesenhadaAcao
                    ]);
                } else {
                    documento.value = formatters.cpfCnpjFormatToNumeral(
                        this.pesquisa
                    );
                }

                documento.type = this.tipoPesquisa;

                let camadasPdf = this.camadasAtivas;

                documento.type = this.tipoPesquisa;
                if (documento.type === 'CPF_CNPJ_NEW') {
                    documento.type = 'CPF_CNPJ';
                }

                if (
                    this.tipoPesquisa === 'GEOMETRIA' &&
                    !this.geometriaSigef &&
                    this.geometriaDesenhadaAcao.type === 'Point'
                ) {
                    camadasPdf = null;
                }

                const params = {
                    idTerritorio: this.territorioId,
                    tipoDocumento:
                        documento.type === 'ARQUIVO'
                            ? 'GEOMETRIA'
                            : documento.type,
                    documento: documento.value,
                    camadas: camadasPdf,
                    buffer: buffer
                        ? JSON.stringify(this.dadosConsultaBuffer.geometria)
                        : null,
                    nomeArquivo: documento.nomeArquivo || null
                };

                const dados = [];
                dados.push(params);

                retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    dados,
                    5000,
                    10
                );
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível exportar o pdf!'
                });
                disconnect();
            }
        },

        marcarExportacaoDiagnosticPdf() {
            let documento = {};

            if (this.tipoPesquisa === 'CODIGOCAR') {
                documento.value = this.pesquisa.toUpperCase();
                documento.nome = 'CAR ' + this.pesquisa;
            } else if (this.tipoPesquisa === 'ARQUIVO') {
                documento.value = JSON.stringify(this.uploadFile.file);
                documento.nome = this.uploadFile.name;
            } else if (this.tipoPesquisa === 'GEOMETRIA') {
                documento.value = JSON.stringify([
                    this.geometriaSigef
                        ? this.geometriaSigef
                        : this.geometriaDesenhadaAcao
                ]);
                documento.nome = 'Geometria';
            } else {
                documento.value = formatters.cpfCnpjFormatToNumeral(
                    this.pesquisa
                );
                documento.nome =
                    'CPF/CNPJ ' +
                    formatters.cpfCnpjFormatToNumeral(this.pesquisa);
            }

            documento.type = this.tipoPesquisa;

            let camadasPdf = this.camadasAtivas;

            let tipoDocumento = this.tipoPesquisa;

            if (this.tipoPesquisa === 'CPF_CNPJ_NEW') {
                tipoDocumento = 'CPF_CNPJ';
            }

            if (this.tipoPesquisa === 'ARQUIVO') {
                tipoDocumento = 'GEOMETRIA';
            }

            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: this.territorioId,
                tipoDocumento,
                documento: documento.value,
                camadas: camadasPdf,
                nome: documento.nome,
                buffer: this.dadosConsultaBuffer
                    ? JSON.stringify(this.dadosConsultaBuffer.geometria)
                    : null,
                nomeArquivo:
                    this.tipoPesquisa === 'ARQUIVO' ? documento.nome : null
            };

            this.setMarcarExportar_PDF(params);
        },

        onLimitExceed() {
            this.$notify.warning({
                message: 'Só é permitido a consulta de um território por vez.'
            });
        },

        onRemoveFile() {
            this.layersMaps = [];
            this.dadosConsultaBuffer = null;
            this.dadosConsulta = null;
            this.uploadFile = null;
            this.geometriaSigef = null;
            this.fileList = [];
        },

        onLoadFile(file) {
            this.layersMaps = [];
            this.geometriaSigef = null;

            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                await geoJsonConverter
                    .parse(extension, e.target.result, file.raw)
                    .then(geoJson => {
                        let dadosArquivo = {
                            id: file.uid,
                            file: geoJson.features.map(f => f.geometry),
                            name: file.name
                        };

                        this.uploadFile = dadosArquivo;

                        this.mostrarTerritorioNoMapa(dadosArquivo.file);
                    })
                    .catch(rejectReason => {
                        this.$refs.upload.clearFiles();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        formatNumber(input, decimalPlaces) {
            return formatters.formatNumber(input, decimalPlaces);
        },

        async buscarCarPorCpfCnpjVinculado(cpfCnpj) {
            try {
                const { data } = await CarService.buscarCarPorCpfCnpjVinculado(
                    cpfCnpj
                );
                return data;
            } catch (error) {
                this.$notify.error({
                    message:
                        'Houve um erro na requisição. Por favor, tente novamente.'
                });
            }
        },

        async buscarDadosSigefCpfCnpj(cpfCnpj) {
            const { data } = await SigefService.consultarCpfCnpj(cpfCnpj);
            return data;
        },

        async buscarDadosSigefINCRA(incra) {
            const { data } = await SigefService.consultarINCRA(incra);
            return data;
        },

        mascaraPesquisa(value) {
            value = value.replace(/[^\w\s]/gi, '');

            if (value.length === 13) {
                return value;
            } else if (value.length <= 14) {
                return formatters.numeralStringFormatTocpfCnpj(value);
            } else if (value.length > 14 && value.length <= 32) {
                return formatters.formatCodigoParcela(value);
            } else {
                return CarUtils.addMascaraCar(value).toUpperCase();
            }
        },

        verificarAtualizacaoMapa() {
            return !this.camadaCentralizadaNome;
        }
    }
};
</script>

<style lang="scss">
#diagnostico-socioambiental-view {
    padding: 20px;
    height: 100%;
    width: 100%;
    display: flex;
    border-radius: 4px;
}

.spaceProximidades {
    margin-top: 5px;
}

.card-socioambiental {
    @include scroll-bar();
    width: 700px;
    background-color: var(--white);
    border: 0;
    border-radius: 5px 0 0 5px;

    padding: 16px;
    overflow: auto;

    header {
        h1 {
            margin-bottom: 16px;
        }

        p {
            font-weight: 500;
        }
    }

    .dados {
        header p {
            margin: 2px 0;
        }

        .valor-pesquisado {
            margin-top: 10px;
            font-weight: bold;
        }

        .resultado-analise-titulo {
            margin-left: 5px;
        }
    }
}

@media (max-width: 900px) {
    #diagnostico-socioambiental-view {
        flex-direction: column;
    }

    .card-socioambiental {
        height: 400px;
        width: 100%;

        .vazio {
            height: 60px;
        }
    }
}

.flexLine {
    display: flex;
    justify-content: space-between;
}

.pesquisa-valida {
    color: var(--white);
}

.pesquisa-invalida {
    color: red;
}

.upload {
    margin-top: 2rem;
}

.el-upload,
.el-upload-dragger {
    width: 100% !important;
    max-width: 100% !important;
}

.downloadMenu {
    min-width: 180px;
}

.el-dropdown-link-exportar {
    border: 1px solid #babac9;
    padding: 10px 20px;
    color: #19194b;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    font-size: 13px !important;

    i {
        margin-right: 5px;
    }
}

.el-dropdown-link-exportar:hover {
    background-color: #e8e8ed;
}

.downloadButton {
    background: transparent !important;
    border: none !important;
    text-align: left !important;
    padding: 0 !important;
}

.exportar-btn {
    display: flex;
    justify-content: space-between;
}

.informacoes-gerais {
    font-size: 13px !important;
    height: 25px !important;
    font-weight: 500;
}

#mapaDiagnosticoSocioambiental {
    border-radius: 0 5px 5px 0;
}
</style>
